import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function UpdateLink() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [adminuid, setAdminuid] = useState({});

  const referral_API = async () => {
    setisLoading(true);
    try {
      let response = await API?.post(
        "/UpdatePHLinkList",
        {
          loginid: userId,
          type: "UpdateLinkList",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      const data = response?.data?.data?.[0] || [];
      const cleanedData = data.map((item) => ({
        sr: item.row,
        id: item?.id,
        fromid: item?.fromid,
        lvl: item?.lvl,
        Link_Amount: item?.Link_Amount,
        ed: item?.ed,
        dd: item?.dd,
        name: item?.fromname,
        Mobile: item?.frommobile,
        email: item?.fromemail,
      }));

      setleftreferralApi(cleanedData);
    } catch (e) {
      console.log("Error in referral_API", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const UpdateLinkId_Api = async (id) => {
    try {
      if (window.confirm("Are you sure, you want to update..?")) {
        let response = await API?.post(
          "/UpdatePhLink",
          {
            loginid: userId,
            id: id,
            uid: adminuid[id] || 0,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        const result = response?.data?.data?.result;
        if (result === "success") {
          toast.success("Link Updated Successfully !!");
          referral_API();
        } else {
          toast.error(result);
        }
      }
    } catch (e) {
      console.log("Error in UpdateLinkId_Api", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  const displayData = currentPostleft.map((item) => ({
    ...item,
    uid: (
      <input
        type="number"
        className="form-control"
        placeholder="Enter User Id"
        value={adminuid[item.id] || ""}
        onChange={(e) =>
          setAdminuid((prev) => ({
            ...prev,
            [item.id]: e.target.value,
          }))
        }
      />
    ),
    update: (
      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={() => UpdateLinkId_Api(item.id)}
      >
        Update
      </button>
    ),
  }));

  const my_team = {
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "From Id", accessor: "fromid" },
      { Header: "Name", accessor: "name" },
      { Header: "Mobie", accessor: "Mobile" },
      { Header: "Email", accessor: "email" },
      { Header: "Level", accessor: "lvl" },
      { Header: "Amount", accessor: "Link_Amount" },
      { Header: "Date", accessor: "dd" },
      { Header: "Expire Date", accessor: "ed" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Update", accessor: "update" },
    ],
  };

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title">Update PH Help Link List</h4>
                </div>
                <div className="panel-body">
                  <div className="row">
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={displayData} columns={my_team.cols} />
                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
